import { useQuery, useInfiniteQuery, useQueryClient, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import API from './utils/api';
import {
    DisciplinaryActionType, DisciplinaryActionTypePaginator,
    CreateDisciplinaryActionTypeDto, QueryDisciplinaryActionTypeDto,
    UpdateDisciplinaryActionTypeDto, SearchDisciplinaryActionTypeDto 
} from '../models/disciplinary-action-type.dto';
import ENDPOINTS from './utils/endpoints';

export function useGetDisciplinaryActionType(options?: QueryDisciplinaryActionTypeDto) {
    const url = ENDPOINTS.HR.DISCIPLINARY_ACTION_TYPE.GET;
    const request = (options: QueryDisciplinaryActionTypeDto) => API.HrAPI.getDisciplinaryActionType(options);

    const { data, isLoading, error, refetch } = useQuery<DisciplinaryActionTypePaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        { ...API.Handlers.pageParamOption},
    );

    return { data, isLoading, error, refetch };
}

export function useGetDisciplinaryActionTypeBySearch() {

    return useMutation(
        (options?: SearchDisciplinaryActionTypeDto) => API.HrAPI.getDisciplinaryActionTypeBySearch(options),
        {
            onSuccess: (response,) => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useGetDisciplinaryActionTypeById(id: number){
    const url = ENDPOINTS.HR.DISCIPLINARY_ACTION_TYPE.DETAIL;
    const request = API.HrAPI.getDisciplinaryActionTypeById(id);

    const { data, isLoading, error } = useQuery<{ data: DisciplinaryActionType }, Error>(
        [url, id],
        (() => request),
        { enabled: !!(id) },
    );
    
    return { data, isLoading, error };
}


export function useCreateDisciplinaryActionType() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ payload }: { payload: CreateDisciplinaryActionTypeDto }) => API.HrAPI.createDisciplinaryActionType(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.HR.DISCIPLINARY_ACTION_TYPE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useUpdateDisciplinaryActionType() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ id, payload }: { id: number, payload: UpdateDisciplinaryActionTypeDto }) => API.HrAPI.updateDisciplinaryActionType(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.HR.DISCIPLINARY_ACTION_TYPE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useDeleteDisciplinaryActionType() {

    return useMutation(
        ({ id }: { id: number }) => API.HrAPI.deleteDisciplinaryActionType(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}